import { webPartsObjs as atomsWebParts } from 'src/features/brands/atoms/constants/bases'

export const seriesObjs = [
  { label: 'BOMBER', value: 'bomber' }
  // { label: 'ノーマル', value: 'normal' }
]

export const dominantArmObjs = [
  { label: '右投げ', value: 'rightThrow' },
  { label: '左投げ', value: 'leftThrow' }
]
export const onlyRightThrowObjs = [{ label: '右投げ', value: 'rightThrow' }]

export const sizeObjs = [
  { label: '10mm大きく', value: 'large10', price: 3300 },
  { label: '5mm大きく', value: 'large5', price: 3300 },
  { label: '基本モデルズバリ', value: 'default', price: 0 },
  { label: '5mm小さく', value: 'small5', price: 3300 },
  { label: '10mm小さく', value: 'small10', price: 3300 }
]
export const backLaceObjs = [
  { label: '有り', value: 'straight', imageUrl: '/gorilla/baseSettings/backLace/exist.jpg' },
  { label: '無し', value: 'none', imageUrl: '/gorilla/baseSettings/backLace/none.jpg' }
]

export const fingerGuardTypeBaseObjs = [
  { label: '指カバー有り', value: 'indexCover', imageUrl: '/gorilla/baseSettings/fingerGuardType/indexCover.jpg' },
  { label: '指アテ有り', value: 'indexPad', imageUrl: '/gorilla/baseSettings/fingerGuardType/indexPad.jpg' },
  { label: '指カバー有り(SKR,BKN用)', value: 'indexAndMiddleTipOutCover' },
  { label: '指アテ有り(SKR用)', value: 'indexAndMiddlePad' },
  { label: '指アテ有り(中指)', value: 'middlePad' },
  { label: '無し', value: 'none' }
]
export const fingerGuardTypeObjs = [
  { label: '指カバー有り', value: 'indexCover', imageUrl: '/gorilla/baseSettings/fingerGuardType/indexCover.jpg' },
  { label: '指アテ有り', value: 'indexPad', imageUrl: '/gorilla/baseSettings/fingerGuardType/indexPad.jpg' },
  { label: '無し', value: 'none', imageUrl: '/gorilla/baseSettings/fingerGuardType/none.jpg' }
]
export const fingerGuardTypeForSkrModelObjs = [
  { label: '指カバー有り(SKR用)', value: 'indexAndMiddleTipOutCover' },
  { label: '無し', value: 'none', imageUrl: '/gorilla/baseSettings/fingerGuardType/none.jpg' }
]
export const fingerGuardTypeForBknModelObjs = [
  {
    label: '指カバー有り(SKR,BKN用)',
    value: 'indexAndMiddleTipOutCover',
    imageUrl: '/gorilla/baseSettings/fingerGuardType/indexAndMiddleTipOutCover.jpg'
  }
]
export const fingerGuardTypeForOutfielderObjs = [
  ...fingerGuardTypeObjs,
  { label: '指アテ有り(中指)', value: 'middlePad', imageUrl: '/gorilla/baseSettings/fingerGuardType/middlePad.jpg' }
]
export const webPartsObjs = atomsWebParts

export const DOMINANT_ARM_BUTTON_OPTION = 'gorilla-dominant-arm-card'
export const FINGER_GUARD_TYPE_BUTTON_OPTION = 'gorilla-finger-guard-type-card'
export const WEB_PARTS_BUTTON_OPTION = 'gorilla-web-parts-card'
export const SIZE_BUTTON_OPTION = 'gorilla-size-button'
export const BACK_LACE_BUTTON_OPTION = 'gorilla-back-lace-card'
